import { useMemo } from "react"

import { GeoJSONSourceSpecification, getLateralizedOffset, offsetFeatureCollectionPixelPerfect, Source, useMapDispatchContext } from "@l2r-front/l2r-map"

import { useRoadRoadsideInventoriesFeatures } from "../../hooks/utils/useRoadRoadsideInventoriesFeatures"

type RoadRoadsideInventoriesSourceProps = GeoJSONSourceSpecification & {
    id?: string,
    road?: string,
    typeCode?: string,
    mapId: string,
    mapZoom: number,
    filterNonWritableFeatures?: boolean,
    children?: React.ReactNode,
}

export function RoadRoadsideInventoriesSource(props: RoadRoadsideInventoriesSourceProps) {
    const {
        road,
        typeCode,
        mapId,
        mapZoom,
        filterNonWritableFeatures = true,
        ...sourceProps
    } = props

    const { getMapRef } = useMapDispatchContext()
    const mapRef = getMapRef(mapId)

    const sanitizedData = useRoadRoadsideInventoriesFeatures(road, typeCode, { filterNonWritableFeatures: filterNonWritableFeatures })

    const offsetedData = useMemo(() => {
        if (!sanitizedData || !mapRef) {
            return null
        }

        const map = mapRef.getMap()

        return offsetFeatureCollectionPixelPerfect(
            map,
            sanitizedData,
            () => getLateralizedOffset(mapZoom),
        )
    }, [sanitizedData, mapRef, mapZoom])

    if (!sanitizedData) {
        return null
    }

    return (
        <Source {...sourceProps} type="geojson" data={offsetedData} tolerance={.001} />
    )
}